import { postData } from '../common/api';
import {
  createAtcPopupOfferRequest,
  createCheckoutRequest,
  getAddtionalOrderProperties,
} from '../common/apiRequest';
import {
  addOrderIDAttributeToCart,
  addVariantsWithQuantityToCart,
  cartHasSellingPlanItem,
  fetchCart,
  getMonkDiscountProperties,
  getVariantsQuantityFromCart,
  increaseQuantityAndGetMrCartForVariantsWithQuantity,
  updateProductIDsInCartForPrimary,
} from '../common/cart';
import { getCheckoutEndpoint, getOfferEndpoint } from '../common/constants';

import {
  getmr_c_internal,
  getmr_atc_internal,
  getmr_bn_internal,
  setmr_bn_internal,
  setmr_atc_internal,
  setmr_c_internal,
  continueEvent,
  getclickingCheckout,
  setclickingCheckout,
  handleElementClick,
  getclickingATC,
  setclickingATC,
} from '../common/html';

import { logger } from '../common/logger';
import { goToCheckout, goToDiscountedCheckout } from '../common/navigation';
import {
  getProductHandleFromURL,
  getShop,
  getTheme,
  isInaEss,
  getIsSellingPlanEnabled,
  getVariantsWithQuantityFromEvent,
  getProductPropertiesFromTarget,
  isMagicInstalled,
  getLocale,
  getCityAndCounty,
} from '../common/pageData';
import {
  getDiscountCodeFromApps,
  getExternalDiscountCodeForFunctions,
  getFLoatingInDisplay,
  getIsShopifyFunctionsEnabled,
  getOffersDisable,
  getOpenDrawer,
  getOrderID,
  getWindoKey,
  isDisabled,
  setBlock,
  setFloatingInDisplay,
  setOfferID,
  setOpenDrawer,
  setOrderID,
  setOrderProperties,
} from '../common/settings';
import { generateString } from '../common/strings';
import { sleep } from '../common/time';
import { extractDirectStateFromReduxStore } from '../common/store';
import { requestForPdpFgUsingStoredData } from '../freegift';
import { filterWidgets } from './commonModuleForEmbeddedAndAutoAdd';
import { mutexManager, StaticMutexKeys } from '../common/mutexmanager';
import { onPopupOfferEligible } from './popupModule';
import {
  getOfferDataForLogs,
  logRuntimeError,
  logtailMiddleware,
} from '../common/utils';

let mr_bn_s = [
  'div.shopify-payment-button',
  '#coca-cta-btn.mfy-sticky-add-to-cart',
];

let mr_c_s = [
  'button.atc-button--checkout', // swanseapods
  '[name=checkout]',
  '[name=ddcheckout]',
  '[name=goto_pp]',
  '[name=goto_gc]',
  'a[href="/checkout"]',
  'a[href^="/checkout"]',
  '[href="/cart/checkout"]',
  '.btn-checkout',
  'button[onclick^="document.getElementById(\'cart_form"]',
  '.satcb-cs-checkout-btn', // https://indy-com-ar.myshopify.com/
  '.mfy-cowi-checkout-button',
  '.btn_checkout',
  '#checkout2',
  'input[value=Checkout]',
  'button.check-out',
  "form[action$='/checkout'] button[type='submit']",
  '#cart-checkout',
  '#cart-sidebar-checkout',
  '.cart-footer__checkout-button',
  'button.cart__checkout',
  '#flo-checkout-btn',
  '.cart__checkout-button',
  '.arrow-monk-cart-checkout',
  'button[onclick^=arrow_clicked_wrapper]', // arrow
  'button[onclick^="window.location=\'/checkout\'"]',
  '#dynamic-checkout-cart li div',
  '#cd_checkout_btn',
  'magic-checkout-btn',
  "button[onclick='handleFloCheckoutBtn()']",
  '.quick-cart__footer .quick-cart__buy-now',
  '#checkout3',
].join(', ');
let mr_atc_s = [
  '#prod_add_to_cart',
  '.product__add-to-cart-button',
  '.tt-btn-addtocart',
  '.add-to-cart',
  '.add_to_cart',
  '.add-to-cart-button',
  '.add_to_cart_button',
  '.button-add-to-cart',
  '.button_add_to_cart',
  '.add-to-cart-btn',
  '.add_to_cart_btn',
  '.btn-add-to-cart',
  '.btn_add_to_cart',
  '.addToCart',
  '.AddToCart',
  '.AddtoCart',
  '.addtocart',
  '.btn-addtocart',
  '.btn--sticky_addtocart',
  '.qsc-btn--add-to-cart',
  '#add-to-cart',
  '#add-to-cart-btn',
  '#btn-add-to-cart',
  '#addToCartButton',
  '#addToCartBtn',
  '#btnAddToCart',
  '#AddToCart',
  '#shopify_add_to_cart',
  '.product-form__add-to-cart',
  '.product-form--add-to-cart', //	alluskin-official.myshopify.com
  '.product-buy-buttons--cta',
  '.single_add_to_cart_button',
]
  .reduce(
    (acc, val) => {
      acc.push(`button${val}`);
      acc.push(`input${val}`);
      acc.push(`a${val}`);
      return acc;
    },
    [
      'form[action*="/cart/add"] button[type=submit]:not(.shopify-payment-button__button):not(.shopify-payment-button__more-options)',
      'form[action*="/cart/add"] input[type=submit]',
      'a[href*="/cart/add"]',
      'form[action$="/cart/add"] #button-cart', // pressreleasehub.myshopify.com
      '.product-atc-btn', // navinastyles.myshopify.com
      'form[action$="/cart/add"] .shg-btn', // zzonk.myshopify.com
      'form[action*="/cart/add"] [data-product-add]', // vitamins-lv.myshopify.com
      '.btn--add-to-cart', // ebuy-world.myshopify.com
      '.product-form--atc-button', // bezali.com
      '.cart__checkout-btn', // tallnya.myshopify.com
      '.product-atc__button', // FBBCApproved.com and TruLean.com
      '.complete-design-a', // cardsplug.com
      '.product_buttonContainer-addToCart a', // messyweekend.jp
      '#mwAddToCart',
      'button[data-zp-link-type="cart"]',
      'button[data-pf-type="ProductATC"]',
      '[data-action="add-to-cart"]',
      '[data-action="AddToCart"]',
      '[name=add]',
      '[name=addToCart]',
      '[name=AddToCart]',
      '.g-stickybar-buynow', // https://apps.shopify.com/straight-to-checkout-skip-cart
      '.productitem--action-atc', // swanseapods.com
      '#button-cart', // theodinvediko.myshopify.com
      "button[type='submit'][data-aid='product-form-submit-button']",
    ]
      .map(selector => `${selector}`)
      .concat([]),
  )
  .join(', ');

const mr_cart_icon_selector =
  "a[href$='/cart'],a.header--cart-toggle,a.header--cart-link,#cart-icon-bubble,.slideout__trigger--open,a.js-call-minicart,.icon--cart,a[data-cart-toggle],.icon-cart,.header__cart-button,.minicart__button,a[data-cart-pc],a[data-mobile-cart],a[href$='/cart/'],a[data-off-canvas--open='right-sidebar']";

let cartIconObs;

const mrObs = new MutationObserver(mutations => {
  const addToCartButtonSwansea = document.getElementsByClassName(
    'product-form--atc-button',
  );

  const buyNowSticky = document.getElementsByClassName('mfy-sticky-bg');
  const checkoutButtonSwansea = document.getElementsByClassName(
    'atc-button--checkout',
  );

  const checkoutButtonsAroma = document.getElementsByClassName(
    'Drawer__Content',
  );

  const minicartFormDTI = document.getElementById('mini-cart');
  const minicartIndy = document.getElementById('satcb_sticky_cart');
  // https://indy-com-ar.myshopify.com/

  const checkoutButtonsUs = document.getElementsByClassName('drawer__footer');
  // withinus.myshopify.com

  const checkoutButtonMangolia = document.getElementsByClassName(
    'ajax-cart__button',
  );

  const checkoutButtons = document.querySelectorAll(mr_c_s);

  // logger.log(mutations);
  for (let i = 0; i < mutations.length; i += 1) {
    const mutation = mutations[i];
    // logger.log(mutation.target);
    if (mutation.type === 'childList') {
      for (let j = 0; j < mutation.addedNodes.length; j += 1) {
        const added = mutation.addedNodes[j];
        // code for miracle tree
        if (added.contains(document.getElementById('ShopNowContainer'))) {
          logger.log('added ShopNowContainer');
          waitForRegister();
        }

        // code for miracle tree
        if (added.contains(document.getElementById('CartContainer'))) {
          logger.log('added cart contatiner');
          waitForRegister();
        }
        // code for jord clothing tree
        if (added.contains(document.getElementById('ajaxCartForm'))) {
          logger.log('added ajaxCartForm contatiner');
          waitForRegister();
        }

        if (
          mutation.target.contains(
            document.getElementById('dynamic-checkout-cart'),
          )
        ) {
          waitForRegister();
        }

        // code for miracle swanseapods
        // add to cart from quick buy popup
        if (addToCartButtonSwansea) {
          // convert to simple for loop
          for (let k = 0; k < addToCartButtonSwansea.length; k += 1) {
            const swnseabtn = addToCartButtonSwansea[k];
            if (added.contains(swnseabtn)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        if (buyNowSticky) {
          for (let k = 0; k < buyNowSticky.length; k += 1) {
            const stickyBtn = buyNowSticky[k];
            if (added.contains(stickyBtn)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        // checkout button on add to cart click popup
        if (checkoutButtonSwansea) {
          for (let k = 0; k < checkoutButtonSwansea.length; k += 1) {
            const swnseabtn = checkoutButtonSwansea[k];
            if (added.contains(swnseabtn)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        // checkout button on add to cart click popup
        if (checkoutButtonsAroma) {
          for (let k = 0; k < checkoutButtonsAroma.length; k += 1) {
            const aromabtn = checkoutButtonsAroma[k];
            if (added.contains(aromabtn)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        if (minicartFormDTI) {
          const checkoutButtonsDTI = document.getElementsByClassName(
            'mini-cart__button-container',
          );

          for (let k = 0; k < checkoutButtonsDTI.length; k += 1) {
            const dtibtn = checkoutButtonsDTI[k];
            if (added.contains(dtibtn)) {
              logger.log('popup modal dti');
              waitForRegister();
              break;
            }
          }
        }

        if (minicartIndy) {
          const minicartIndyBtns = document.getElementsByClassName(
            'satcb-cs-checkout-btn',
          );

          for (let k = 0; k < minicartIndyBtns.length; k += 1) {
            const btn = minicartIndyBtns[k];
            if (added.contains(btn)) {
              logger.log('popup modal indy');
              waitForRegister();
              break;
            }
          }
        }

        // checkout button on add to cart click popup
        if (checkoutButtonsUs) {
          for (let k = 0; k < checkoutButtonsUs.length; k += 1) {
            const ele = checkoutButtonsUs[k];
            if (added.contains(ele)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        // checkout button on add to cart click popup
        if (checkoutButtonMangolia) {
          for (let k = 0; k < checkoutButtonMangolia.length; k += 1) {
            const ele = checkoutButtonMangolia[k];
            if (added.contains(ele)) {
              logger.log('popup modal');
              waitForRegister();
              break;
            }
          }
        }

        if (checkoutButtons) {
          for (let k = 0; k < checkoutButtons.length; k += 1) {
            const ele = checkoutButtons[k];
            if (added.contains(ele)) {
              logger.log('checkout button creation');
              waitForRegister();
              break;
            }
          }
        }
      }
    }
  }
});

const registerSettings = {
  isPopupEnabled: false,
  isVDAboveATCEnabled: false,
  isProductAddonsAboveATCEnabled: false,
  cartPageDiscountConfig: {},
  isDiscountCodeEnabled: false,
  store: {},
  widgets: [],
  isCVBEnabled: false,
  buttonSelectors: '',
};

function waitForRegister() {
  const waitRegister = setInterval(() => {
    const registered = register({
      isPopupEnabled: registerSettings.isPopupEnabled,
      isVDAboveATCEnabled: registerSettings.isVDAboveATCEnabled,
      isProductAddonsAboveATCEnabled:
        registerSettings.isProductAddonsAboveATCEnabled,
      cartPageDiscountConfig: registerSettings.cartPageDiscountConfig,
      isDiscountCodeEnabled: registerSettings.isDiscountCodeEnabled,
      store: registerSettings.store,
      widgets: registerSettings.widgets,
      isCVBEnabled: registerSettings.isCVBEnabled,
      buttonSelectors: registerSettings.buttonSelectors,
    });
    if (registered === true) {
      clearInterval(waitRegister);
    }
  }, 1000);
}

function register({
  isPopupEnabled,
  isVDAboveATCEnabled,
  isProductAddonsAboveATCEnabled,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  store,
  widgets,
  isCVBEnabled,
  buttonSelectors,
}) {
  let found = false;

  // don't intercept atc click for these products for this store
  if (
    getShop() === 'herbn-eden.myshopify.com' &&
    (window.location.href.includes('/products/5-for-25-bundle') ||
      window.location.href.includes('/products/4oz-body-butter-set') ||
      window.location.href.includes('/products/8oz-body-butter-set'))
  ) {
    mr_atc_s = 'mr-na';
  }

  if (getShop() === 'pabebaby.myshopify.com') {
    mr_c_s = `.cart__footer button[type=button], ${mr_c_s}`;
  }

  if (getShop() === 'yummie-eu.myshopify.com') {
    mr_c_s = '[name=checkout]';
  }

  if (getShop() === 'elizabeth-scarlett.myshopify.com') {
    mr_c_s = '.minicart__footer a.btn';
  }

  if (
    [
      'xyzskincare.myshopify.com',
      'skincaresite.myshopify.com',
      'plentifulskin.myshopify.com',
    ].includes(getShop())
  ) {
    mr_c_s = '#checkout';
  }

  const {
    addToCart: atcSelector,
    checkout: checkoutSelector,
    buyNow: buyNowSelector,
  } = buttonSelectors;

  if (atcSelector) {
    mr_atc_s = atcSelector;
  }

  if (checkoutSelector) {
    mr_c_s = checkoutSelector;
  }

  if (buyNowSelector) {
    mr_bn_s = buyNowSelector;
  }

  const checkoutButtons = document.querySelectorAll(mr_c_s);
  for (let i = 0; i < checkoutButtons.length; i += 1) {
    const button = checkoutButtons[i];
    if (isDisabled() !== 'true') {
      if (button.getAttribute('mr-click') !== 'true') {
        button.setAttribute('mr-click', 'true');
        button.addEventListener(
          'click',
          event =>
            onCheckoutClick(event, {
              cartPageDiscountConfig,
              isDiscountCodeEnabled,
              widgets,
              isCVBEnabled,
            }),
          true,
        );
        logger.Debug('registered checkout', button);
      }
    }
    found = true;
  }

  if (getShop() === 'arabicjewelry.myshopify.com') {
    mr_atc_s = `a.button.submit-btn.js-fake-submit, ${mr_atc_s}`;
  }

  if (getShop() === 'shoptikidemo.myshopify.com') {
    mr_atc_s = `.product-badge,${mr_atc_s}`;
  }

  if (isPopupEnabled || isVDAboveATCEnabled || isProductAddonsAboveATCEnabled) {
    const addToCartButtons = document.querySelectorAll(mr_atc_s);
    for (let i = 0; i < addToCartButtons.length; i += 1) {
      const button = addToCartButtons[i];
      if (isDisabled() !== 'true') {
        logger.Debug('registered', button, button.getAttribute('mr-click'));
        if (
          button.getAttribute('mr-click') !== 'true' ||
          getShop() === 'longevitybox.myshopify.com'
        ) {
          button.setAttribute('mr-click', 'true');
          button.addEventListener(
            'click',
            event =>
              onAddToCartClick(event, {
                isPopupEnabled,
                isVDAboveATCEnabled,
                isProductAddonsAboveATCEnabled,
                store,
              }),
            true,
          );
        }
      }
      found = true;
    }
    const buyNowButtons = document.querySelectorAll(mr_bn_s);
    for (let i = 0; i < buyNowButtons.length; i += 1) {
      const button = buyNowButtons[i];
      if (isDisabled() !== 'true') {
        logger.Debug('registered buy now');
        if (button.getAttribute('mr-click') !== 'true') {
          button.setAttribute('mr-click', 'true');
          button.addEventListener('click', onBuyNowClick, true);
        }
      }
      found = true;
    }
  }

  return found;
}

export function setATCButtonLoading(event, loading) {
  if (isInaEss()) {
    if (event.target) {
      const btn = event.target.closest('button');
      if (btn) {
        btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
    }
  }
}

export function setCheckoutButtonLoading(event, loading) {
  if (isInaEss()) {
    if (event.target) {
      const btn = event.target.closest('button');
      if (btn) {
        btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
    }
  }
}

async function renderingThePopup({
  variantsWithOldQuantity,
  variantsWithQuantity,
  cartWithUpdatedProductIDs,
  offer,
  eventID,
  event,
  trigger,
}) {
  const popupModule = await import('./popupModule');

  popupModule.renderInDiv({
    products: offer.offered,
    open: true,
    expand: true,
    mrOfferID: offer.mr_offer_id,
    primary: offer.primary,
    loadingOffer: false,
    theme: offer.theme,
    isTimerDisabled: offer.isTimerDisabled,
    isDiscountDisabled: offer.isDiscountDisabled,
    timer: offer.timer,
    trigger,
    eventID,
    cart: cartWithUpdatedProductIDs,
    event,
    variantsWithOldQuantity,
    triggerType: offer.triggerType,
    floatingDisabled: offer.floatingDisabled,
    offerType: offer.type,
    currencyFormat: offer.currencyFormat,
    discountType: offer.discountType,
    discountValue: offer.discountValue,
    discountQuantity: offer.discountQuantity,
    isDiscountQuantityRestricted: offer.isDiscountQuantityRestricted,
    isNumberOfOfferedProductsRestricted:
      offer.isNumberOfOfferedProductsRestricted,
    isDiscountCodeApplicable: offer.isDiscountCodeApplicable,
    isDisableOfferOnClose: offer.isDisableOfferOnClose,
    checkoutOnSkip: false,
    isBrandingEnabled: offer.isBrandingEnabled,
    priceRoundType: offer.priceRoundType,
    discountRoundType: offer.discountRoundType,
    offerLevelDiscountQuantity: offer.offerLevelDiscountQuantity,
    variantsWithQuantityFromPdp: variantsWithQuantity,
  });
}

export function getVariantsWithQuantityForAddons({
  variantsWithQuantity = [],
  primary,
  isSellingPlanEnabled,
}) {
  if (!primary || variantsWithQuantity.length === 0) return [];

  let result = [];
  for (let i = 0; i < variantsWithQuantity.length; i += 1) {
    const variantToFill = {
      id: primary.sp_product_id,
      variants: [{ id: variantsWithQuantity[i].sp_variant_id }],
      properties: variantsWithQuantity[i].properties || {},
    };
    if (isSellingPlanEnabled && variantsWithQuantity[i].selling_plan)
      variantToFill.selling_plan = variantsWithQuantity[i].selling_plan;

    result = result.concat(
      Array(variantsWithQuantity[i].quantity).fill(variantToFill),
    );
  }

  return result;
}

async function pdpPopupOfferCallOnBtnClick({ variantsWithQuantity, trigger }) {
  const cart = await fetchCart();
  const { token } = cart;
  // Adding variants with quantity to the cart because the backend needs it to determine the eligibility
  const cartContainingVariantsWithQuantity = increaseQuantityAndGetMrCartForVariantsWithQuantity(
    cart,
    variantsWithQuantity,
  );
  const offerRequestPayload = createAtcPopupOfferRequest({
    trigger,
    cart_token: token,
    cart: cartContainingVariantsWithQuantity,
    variantsWithQuantity,
  });
  const offerResponse = await postData(getOfferEndpoint(), offerRequestPayload);
  return {
    offerResponse,
    cartInOfferRequest: cartContainingVariantsWithQuantity,
  };
}

async function onAddToCartClick(
  event,
  {
    isPopupEnabled,
    isVDAboveATCEnabled,
    isProductAddonsAboveATCEnabled,
    store,
  },
) {
  const evtID = generateString(5);
  logger.log('atc start', evtID);
  try {
    // if disabled don't do anything
    if (isDisabled() === 'true') {
      return true;
    }

    if (getOffersDisable('product') === 'true') {
      return true;
    }

    if (getclickingATC()) {
      setclickingATC(false);

      logger.log('duplicate click', evtID);

      // double event triggers handling
      if (['manchester-museum.myshopify.com'].includes(getShop())) {
        logger.log('stop', evtID);
        stopEvent(event);
        return false;
      }
    }
    setclickingATC(true);

    const start = performance.now();
    logger.log('add to cart clicked', evtID, event);

    let embeddedModule;

    // retrieve product data from Product page form and event
    // const productID = 0;
    const productInformation = getProductInformation(event);
    const {
      isSellingPlanEnabled, // is product with subscription
      // properties, // product properties to be added with the cart/order
    } = productInformation;

    let { variantsWithQuantity } = productInformation; // variantIDs with quantity & properties retrieved from product page

    const globalReducerState = extractDirectStateFromReduxStore(
      store,
      'global',
    );

    // extract state from VD widget if isVDAboveATCEnabled and vd widget is rendered on the page
    let volumeDiscountPageState = {};
    if (isVDAboveATCEnabled && globalReducerState.isVDAboveATCRendered) {
      volumeDiscountPageState = extractDirectStateFromReduxStore(
        store,
        'volumeDiscountPage',
      );
    }
    // extract state from embedded(productAddon) widget if isProductAddonsAboveATCEnabled and pa widget is rendered on the page
    let embeddedPageState = { selectedCheckboxProducts: [] };
    if (
      isProductAddonsAboveATCEnabled &&
      globalReducerState.isProductAddonsAboveATCRendered
    ) {
      embeddedPageState = extractDirectStateFromReduxStore(
        store,
        'embeddedPage',
      );
    }

    // Always stop event if UserClick and for internal click only if required
    if (getmr_atc_internal()) {
      if (
        (isVDAboveATCEnabled && volumeDiscountPageState.selectedVDOption) ||
        (isProductAddonsAboveATCEnabled &&
          embeddedPageState.selectedCheckboxProducts.length > 0)
      ) {
        stopEvent(event);
      }
    } else {
      stopEvent(event);
      logger.log('event stopped', evtID);
    }

    setATCButtonLoading(event, true);
    // update variantsWithQuantity with VD minimum quantity if required
    if (isVDAboveATCEnabled && volumeDiscountPageState.selectedVDOption) {
      variantsWithQuantity = getVariantsWithQuantityWithVDOptionQuantity({
        event,
        defaultVariantID: volumeDiscountPageState.primaryProduct.sp_variant_id,
        currVariantsWithQuantity: variantsWithQuantity,
        volumeDiscountPageState,
      });
    }

    // update variantsWithQuantity for above atc embedded offer
    if (
      isProductAddonsAboveATCEnabled &&
      embeddedPageState.selectedCheckboxProducts &&
      embeddedPageState.selectedCheckboxProducts.length !== 0
    ) {
      variantsWithQuantity = getVariantsWithQuantityWithProducAddons({
        currVariantsWithQuantity: variantsWithQuantity,
        embeddedPageState,
        isSellingPlanEnabled,
      });
    }

    // continue with updated variantsWithQuantity for popup or internal click

    // Check if isVDAboveATCEnabled or isProductAddonsAboveATCEnabled on internal click and update cart
    // else if internal click, set internal as false and continue with click
    if (getmr_atc_internal()) {
      setmr_atc_internal(false);
      logger.Debug('internal clickk');

      // check if variantsWithQuantity are extracted from the shopify theme form
      if (variantsWithQuantity.length === 0) {
        logger.log('could not identify variants with quantity');
        setclickingATC(false);
        return true;
      }

      if (isVDAboveATCEnabled || isProductAddonsAboveATCEnabled) {
        embeddedModule = await import('./embeddedModule');
        const volumeDiscountModule = await import('./volumeDiscountModule');

        if (isVDAboveATCEnabled) {
          logger.log('checking VD for above ATC');

          if (volumeDiscountPageState.selectedVDOption) {
            await volumeDiscountModule.addVDSelectedVariantsForAboveATC({
              mrOfferID: volumeDiscountPageState.mrOfferID,
              productID: volumeDiscountPageState.primaryProduct.sp_product_id,
              totalValues: volumeDiscountPageState.totalDisplayOfferValues,
              selectedVDOption: volumeDiscountPageState.selectedVDOption,
              variantsWithQuantity,
              theme: volumeDiscountPageState.theme,
              dispatch: store.dispatch,
            });
            variantsWithQuantity = [];
          }
        }

        if (isProductAddonsAboveATCEnabled) {
          const updatedVariantsWithQuantity = getVariantsWithQuantityForAddons({
            variantsWithQuantity,
            primary: embeddedPageState.primaryProduct,
            isSellingPlanEnabled,
          });

          if (embeddedPageState.selectedCheckboxProducts.length > 0) {
            await embeddedModule.addProductAddonsToCart({
              mrOfferID: embeddedPageState.mrOfferID,
              selectedCheckboxProducts: updatedVariantsWithQuantity,
              theme: embeddedPageState.theme,
              dispatch: store.dispatch,
              isAboveATC: true,
              isSellingPlanEnabled,
              widgetID: embeddedPageState.productAddOnsWidgetId,
            });
          }
        }
        setclickingATC(false);
        logger.log('return true');
        return true;
      }
      setclickingATC(false);
      return true;
    }

    let noError = false;

    const eventID = generateString(5);

    const pdpPopupMutex = mutexManager.getMutex(StaticMutexKeys.PDP_POPUP);
    try {
      // import popupModule only if Popup is enabled
      if (isPopupEnabled) {
        await pdpPopupMutex.acquire();
        const mrPdpPopupOfferData = getWindoKey('mrPdpPopupOfferData');
        let offerResponse = null;
        let cartInOfferRequest = [];

        // if there is no pre-fetched data, we need to call the offer API
        if (!mrPdpPopupOfferData && variantsWithQuantity.length > 0) {
          const offerResponseOnAtcClick = await pdpPopupOfferCallOnBtnClick({
            variantsWithQuantity,
            trigger: 'atc',
          });
          offerResponse = offerResponseOnAtcClick.offerResponse;
          cartInOfferRequest = offerResponseOnAtcClick.cartInOfferRequest;
        }

        if (mrPdpPopupOfferData) {
          offerResponse = mrPdpPopupOfferData.offerResponse;
          cartInOfferRequest = mrPdpPopupOfferData.cartInOfferRequest;
        }

        const { is_eligible, offer } = offerResponse;

        if (!is_eligible || variantsWithQuantity.length === 0) {
          continueEvent(event, 'atc');
          logger.Debug(performance.now() - start, 'time taken 1');
          noError = true;
          return false;
        }

        // storing old_cart to revert cart to old_cart after popup interaction is done
        const cart = await fetchCart();
        logger.Debug('old_cart', cart);

        const variantsWithOldQuantity = getVariantsQuantityFromCart(
          variantsWithQuantity,
          cart,
        );

        const cartWithUpdatedProductIDs = updateProductIDsInCartForPrimary({
          cart: cartInOfferRequest,
          variantsWithQuantity: offer.variantsWithQuantity,
        });

        renderingThePopup({
          variantsWithOldQuantity,
          variantsWithQuantity,
          cartWithUpdatedProductIDs,
          offer,
          eventID,
          event,
          trigger: 'atc',
        });

        await onPopupOfferEligible({ offer });

        noError = true;
        logger.Debug(performance.now() - start, 'time taken 2');
        return false;
      }
      if (!isPopupEnabled) {
        noError = true;
        if (getShop() === 'yoga-studio-store.myshopify.com') {
          await sleep(1000);
        }

        if (getShop() === 'melu-kids-de.myshopify.com') {
          await sleep(1000);
        }
        logger.log("continue event as popup isn't enabled", evtID);
        continueEvent(event, 'atc');
      }
    } catch (e) {
      // setting true so that finally doesnot execute
      noError = true;
      logger.log('error occured', 'skipping', e);
      continueEvent(event, 'atc');
    } finally {
      pdpPopupMutex.release();
      if (noError === false) {
        logger.log('error occured', 'skipping finally');
        continueEvent(event, 'atc');
      }
    }
    return false;
  } finally {
    logger.log('atc end', evtID);
    setATCButtonLoading(event, false);
  }
}

async function onBuyNowClick(event) {
  const start = performance.now();
  logger.Debug('buy now clicked', event);
  const eventID = generateString(5);
  // if internal click, set internal as false and continue with click
  if (getmr_bn_internal()) {
    setmr_bn_internal(false);
    logger.Debug('internal clickk');
    return true;
  }

  // if disabled don't do anything
  if (isDisabled() === 'true') {
    return true;
  }

  if (getOffersDisable('product') === 'true') {
    return true;
  }
  stopEvent(event);
  let noError = false;
  const pdpPopupMutex = mutexManager.getMutex(StaticMutexKeys.PDP_POPUP);
  try {
    await pdpPopupMutex.acquire();
    const mrPdpPopupOfferData = getWindoKey('mrPdpPopupOfferData');

    const popupModule = await import('./popupModule');
    const variantsWithQuantity = popupModule.getVariantsWithQuantityFromEvent(
      event,
    );

    logger.Debug('variantsWithQuantity', variantsWithQuantity);

    let offerResponse = null;
    let cartInOfferRequest = [];

    // if there is no pre-fetched data, we need to call the offer API
    if (!mrPdpPopupOfferData && variantsWithQuantity.length > 0) {
      const offerResponseOnAtcClick = await pdpPopupOfferCallOnBtnClick({
        variantsWithQuantity,
        trigger: 'bn',
      });
      offerResponse = offerResponseOnAtcClick.offerResponse;
      cartInOfferRequest = offerResponseOnAtcClick.cartInOfferRequest;
    }

    if (mrPdpPopupOfferData) {
      offerResponse = mrPdpPopupOfferData.offerResponse;
      cartInOfferRequest = mrPdpPopupOfferData.cartInOfferRequest;
    }

    const { is_eligible, offer } = offerResponse;

    if (!is_eligible || variantsWithQuantity.length === 0) {
      continueEvent(event, 'bn');
      logger.Debug(performance.now() - start, 'time taken 3');
      noError = true;
      return false;
    }

    const cart = await fetchCart();
    logger.log('old_cart', cart);

    const variantsWithOldQuantity = getVariantsQuantityFromCart(
      variantsWithQuantity,
      cart,
    );

    const cartWithUpdatedProductIDs = updateProductIDsInCartForPrimary({
      cart: cartInOfferRequest,
      variantsWithQuantity: offer.variantsWithQuantity,
    });

    renderingThePopup({
      variantsWithOldQuantity,
      variantsWithQuantity,
      cartWithUpdatedProductIDs,
      offer,
      eventID,
      event,
      trigger: 'bn',
    });

    await onPopupOfferEligible({ offer });

    noError = true;
    return true;
  } catch (e) {
    // setting true so that finally doesnot execute
    noError = true;
    logger.log('error occurred, continue', e);
    continueEvent(event, 'bn');
  } finally {
    pdpPopupMutex.release();
    setclickingATC(false);
    if (noError === false) {
      logger.log('error occured', 'skipping finally');
      continueEvent(event, 'bn');
    }
  }
  return true;
}

async function onCheckoutClick(
  event,
  { cartPageDiscountConfig, isDiscountCodeEnabled, isCVBEnabled, widgets },
) {
  try {
    const evtID = generateString(5);

    // if disabled don't do anything
    if (isDisabled() === 'true') {
      return true;
    }

    // note: in case of magic don't intercept the button click
    if (isMagicInstalled()) {
      return true;
    }

    if (getclickingCheckout()) {
      setclickingCheckout(false);

      logger.log('duplicate click', evtID);

      // double event triggers handling
      if (
        [
          'meineravendeals.myshopify.com',
          'liebeselement.myshopify.com',
          'quirky-perks-new.myshopify.com',
        ].includes(getShop())
      ) {
        logger.log('stop', evtID);
        stopEvent(event);
        return false;
      }
    }
    setclickingCheckout(true);

    logger.log('checkout clicked', evtID, 'isInternal', getmr_c_internal());
    if (getmr_c_internal()) {
      setmr_c_internal(false);
      logger.Debug('internal click', evtID);
      return true;
    }
    stopEvent(event);
    setCheckoutButtonLoading(event, true);

    let noError = false;
    // let cartChangedForFreegift = false;
    // let cartChangedForManualFreegift = false;
    try {
      // const { isCartChanged: isChangedAuto } = await executeFreegiftConditions({
      //   availingType: 'auto_add',
      // });
      // cartChangedForFreegift = isChangedAuto;

      // const {
      //   isCartChanged: isChangedManual,
      // } = await executeFreegiftConditions({
      //   availingType: 'manual_selection',
      // });
      // cartChangedForManualFreegift = isChangedManual;

      if (
        isCVBEnabled &&
        !isInaEss() &&
        !['muse-india.myshopify.com'].includes(getShop())
      ) {
        const cvbModule = await import('./cvbModule');
        await cvbModule.checkCVBAndDisplay({
          widgets,
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      }

      const {
        response: monkCheckoutResponse,
        checkoutReq,
        appliedShopifyFunctionCodes,
        shopifyFunctionsCheckoutURL,
        isStorefrontCart,
      } = await monkCheckout();

      const response = monkCheckoutResponse || {};

      logger.log('response', response, evtID);
      if (!response.is_eligible && response.discount_applicable) {
        // for zero discount add an attribute to cart so that
        // it can be detected in webhook to backend.
        // continue as normal checkout so that discount codes can be applied
        if (response.isZeroDiscount) {
          await addOrderIDAttributeToCart(getOrderID());

          // for shopify functions sometimes the discount codes doesn't apply
          // so redirect to the functions checkout url based for specific stores
          const isCustomCheckout = await storeSpecificShopifyFunctionsCheckout({
            shopifyFunctionsCheckoutURL,
            appliedShopifyFunctionCodes,
            isStorefrontCart,
          });
          if (isCustomCheckout) {
            noError = true;
            return;
          }

          // here the form discount code is not working so redirect to checkout
          if (
            appliedShopifyFunctionCodes.length > 0 &&
            getShop() === 'candycoatgels.myshopify.com'
          ) {
            goToDiscountedCheckout(response, appliedShopifyFunctionCodes);
            noError = true;
            return;
          }

          // if (cartChangedForFreegift || cartChangedForManualFreegift) {
          //   goToCheckout({
          //     discountCodes: appliedShopifyFunctionCodes,
          //     isStorefrontCart,
          //   });
          // } else {
          continueEvent(event, 'c');
          // }
          noError = true;
          return;
        }

        if (response.discountCode && response.discountCode.displayPopup) {
          const discountCodeModule = await import('./discountCodeModule');
          discountCodeModule.renderDiscountCodePopupInDiv({
            open: true,
            theme: response.discountCode.theme,
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
          });
          noError = true;
          return;
        }

        goToDiscountedCheckout(response, appliedShopifyFunctionCodes);
        noError = true;
        return;
      }
      if (response.is_eligible === true) {
        const { offered } = response.offer;
        setOrderID(response.order_id);
        setOfferID(response.offer.mr_offer_id);
        setFloatingInDisplay(true);
        const popupModule = await import('./popupModule');
        popupModule.renderInDiv({
          products: offered,
          open: true,
          expand: true,
          primary: response.offer.primary,
          loadingOffer: false,
          theme: response.offer.theme,
          isTimerDisabled: response.offer.isTimerDisabled,
          isDiscountDisabled: response.offer.isDiscountDisabled,
          timer: response.offer.timer,
          trigger: 'c',
          eventID: generateString(5),
          cart: checkoutReq.cart,
          event,
          old_qty: 0,
          triggerType: response.offer.triggerType,
          floatingDisabled: response.offer.floatingDisabled,
          offerType: response.offer.type,
          currencyFormat: response.offer.currencyFormat,
          discountType: response.offer.discountType,
          discountValue: response.offer.discountValue,
          discountQuantity: response.offer.discountQuantity,
          isDiscountQuantityRestricted:
            response.offer.isDiscountQuantityRestricted,
          isNumberOfOfferedProductsRestricted:
            response.offer.isNumberOfOfferedProductsRestricted,
          isDiscountCodeApplicable: response.offer.isDiscountCodeApplicable,
          isDisableOfferOnClose: response.offer.isDisableOfferOnClose,
          checkoutOnSkip: response.discount_applicable,
          isBrandingEnabled: response.offer.isBrandingEnabled,
          priceRoundType: response.offer.priceRoundType,
          discountRoundType: response.offer.discountRoundType,
          offerLevelDiscountQuantity: response.offer.offerLevelDiscountQuantity,
        });

        popupModule.onPopupOfferEligible({ offer: response.offer });
      } else {
        // remove the monk identifier if no offers are applicable
        // and the monk identifier is set in cart
        if (
          checkoutReq.properties &&
          checkoutReq.properties.mrOrderID &&
          checkoutReq.properties.mrOrderID !== ''
        ) {
          await addOrderIDAttributeToCart('');
        }

        // if (cartChangedForFreegift || cartChangedForManualFreegift) {
        //   goToCheckout({
        //     discountCodes: appliedShopifyFunctionCodes,
        //     isStorefrontCart,
        //   });
        // } else {
        // continueEvent(event, 'c');
        // }
        if (appliedShopifyFunctionCodes.length > 0) {
          goToCheckout({
            discountCodes: appliedShopifyFunctionCodes,
            isStorefrontCart,
          });
        } else {
          continueEvent(event, 'c');
        }
      }

      noError = true;
    } catch (e) {
      // setting true so that finally doesnot execute
      noError = true;
      logger.log(e.message);
      if (e instanceof TypeError && e.message === 'Load failed') {
        return false;
      }

      logger.log('exception continuing', e);
      continueEvent(event, 'c');
      logger.log('exception continuing', e.stack);
    } finally {
      setclickingCheckout(false);
      if (noError === false) {
        logger.log('error occured', 'skipping finally');
        // continueEvent(event, "c");
      }
      setCheckoutButtonLoading(event, false);
    }
  } finally {
    setCheckoutButtonLoading(event, false);
  }
}

export async function monkCheckout() {
  // if floating is in display then don't check for offers
  let checkOffer = !getFLoatingInDisplay() && !getOffersDisable('checkout');
  if (isInaEss()) {
    checkOffer = false;
  }

  if (isMagicInstalled()) {
    checkOffer = false;
  }

  const properties = getAddtionalOrderProperties();
  setOrderProperties(properties);
  const {
    orderRequest: checkoutReq,
    appliedShopifyFunctionCodes,
    shopifyFunctionsCheckoutURL,
    isStorefrontCart,
  } = await createCheckoutRequest(
    'cart',
    null,
    checkOffer,
    getDiscountCodeFromApps(),
  );
  const response = await postData(getCheckoutEndpoint(), checkoutReq);
  if (response.is_eligible) {
    logtailMiddleware({
      widgetId: 0,
      basicOfferData: getOfferDataForLogs({
        offerType: response.offer.type,
        offer: response.offer,
      }),
      offerName: response.offer.type,
    });
  }

  return {
    checkoutReq,
    response,
    appliedShopifyFunctionCodes,
    shopifyFunctionsCheckoutURL,
    isStorefrontCart,
  };
}

async function registerCartIconClick({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isShipProEnabled,
  isCVBEnabled,
  isEmbeddedEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isAnyFeatureEnabled,
  isAutoFreegiftEnabled,
  cartIconConfig,
  widgets,
}) {
  let { selector } = cartIconConfig;
  let isCartIconConfig = true;
  if (!selector) {
    isCartIconConfig = false;
    selector = mr_cart_icon_selector;
  }

  const clickElements = document.querySelectorAll(selector);

  let embeddedModule;
  let cvbModule;
  let subscriptionUpsellModule;
  let cartDiscountModule;
  let shipProModule;
  let autoAddFreegiftModule;
  if (isEmbeddedEnabled) {
    embeddedModule = await import('./embeddedModule');
  }
  if (isAutoFreegiftEnabled) {
    autoAddFreegiftModule = await import('./autoAddFreegift');
  }

  if (isCVBEnabled) {
    cvbModule = await import('./cvbModule');
  }

  if (isSubscriptionUpsellEnabled) {
    subscriptionUpsellModule = await import('./subscriptionUpsellModule');
  }

  if (isShipProEnabled) {
    shipProModule = await import('./shipProModule');
  }

  if (isAnyFeatureEnabled) {
    cartDiscountModule = await import('../cartDiscount');
  }

  for (let i = 0; i < clickElements.length; i += 1) {
    const element = clickElements[i];
    if (
      element.getAttribute('mr-embedded-click') !== 'true' &&
      (element.offsetHeight > 0 || element.getBoundingClientRect().height > 0)
    ) {
      element.setAttribute('mr-embedded-click', 'true');
      // eslint-disable-next-line no-loop-func
      element.addEventListener('click', async () => {
        await sleep(300);

        if (isEmbeddedEnabled) {
          embeddedModule.checkEmbeddedCartAndCheckoutPageWidgets({
            widgets,
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
          });

          requestForPdpFgUsingStoredData({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            isCalledFromCartDrawer: true,
          });
        }

        if (isAutoFreegiftEnabled) {
          const filteredWidgets = filterWidgets({
            offerTypes: ['freegift'],
            displayType: 'embedded',
            widgets,
            availingType: 'auto_add',
            triggerTypes: ['cart_page', 'checkout_page'],
          });
          if (filteredWidgets.length > 0) {
            autoAddFreegiftModule.checkFGAutoAddCartAndCheckoutPageOffer({
              widgets: filteredWidgets,
              cartPageDiscountConfig,
              isDiscountCodeEnabled,
            });
          }

          requestForPdpFgUsingStoredData({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            isCalledFromCartDrawer: true,
          });
        }

        if (isCVBEnabled) {
          await cvbModule.checkCVBAndDisplay({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        }

        if (isShopifyFunctionsEnabled && isSubscriptionUpsellEnabled) {
          subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
            widgets,
          });
        }

        if (isShipProEnabled) {
          shipProModule.checkShippingProtectionAndDisplay({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
            widgets,
          });
        }

        if (isAnyFeatureEnabled) {
          cartDiscountModule.checkAndUpdateCartDiscount({
            cartPageDiscountConfig,
            isDiscountCodeEnabled,
          });
        }
      });
      logger.log('registered cart icon trigger', element);
      if (!isCartIconConfig) {
        break;
      }
    }
  }
}

export const cartPageOfferOnHoverRegister = async ({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isShipProEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  widgets,
}) => {
  const storeTheme = getTheme();
  let cvbModule;
  let embeddedModule;
  let subscriptionUpsellModule;
  let shipProModule;
  let autoAddFreegiftModule;

  if (isCVBEnabled) {
    cvbModule = await import('./cvbModule');
  }
  if (isEmbeddedEnabled) {
    embeddedModule = await import('./embeddedModule');
  }
  if (isAutoFreegiftEnabled) {
    autoAddFreegiftModule = await import('./autoAddFreegift');
  }

  if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
    subscriptionUpsellModule = await import('./subscriptionUpsellModule');
  }

  if (isShipProEnabled) {
    shipProModule = await import('./shipProModule');
  }

  const onFound = async () => {
    if (isEmbeddedEnabled) {
      embeddedModule.checkEmbeddedCartAndCheckoutPageWidgets({
        widgets,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
      });
    }

    if (isAutoFreegiftEnabled) {
      const filteredWidgets = filterWidgets({
        offerTypes: ['freegift'],
        displayType: 'embedded',
        widgets,
        availingType: 'auto_add',
        triggerTypes: ['cart_page', 'checkout_page'],
      });
      if (filteredWidgets.length > 0) {
        autoAddFreegiftModule.checkFGAutoAddCartAndCheckoutPageOffer({
          widgets: filteredWidgets,
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      }
    }

    if (isShipProEnabled) {
      shipProModule.checkShippingProtectionAndDisplay({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        widgets,
      });
    }

    if (isCVBEnabled) {
      await cvbModule.checkCVBAndDisplay({
        retryContainerCreation: true,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        widgets,
      });
    }

    if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
      subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
        widgets,
      });
    }

    const cartDiscountModule = await import('../cartDiscount');
    cartDiscountModule.checkAndUpdateCartDiscount({
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
    });
  };

  if (storeTheme && storeTheme.name === 'Turbo') {
    registerClassChangeListener({
      selector: '.cart-container,.cart_container',
      newClass: 'active_link',
      onFound,
    });
  }

  if (getShop() === 'flyte70-com.myshopify.com') {
    registerClassChangeListener({
      selector: '#bagtooltip',
      newClass: 'force-show',
      onFound,
    });
  }

  if (getShop() === 'pdcstore.myshopify.com') {
    registerStyleChangeListener({
      selector: '#rightmenu',
      attributeName: 'display',
      attributeValue: 'block',
      onFound,
    });
  }
};

export const registerDocumentPageDisplay = ({
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isShipProEnabled,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  widgets,
}) => {
  if (getShop() !== 'deichbrise-onlineshop.myshopify.com') {
    return;
  }

  window.addEventListener('pageshow', async () => {
    let cvbModule;
    let embeddedModule;
    let subscriptionUpsellModule;
    let shipProModule;
    let autoAddFreegiftModule;

    if (isCVBEnabled) {
      cvbModule = await import('./cvbModule');
    }
    if (isEmbeddedEnabled) {
      embeddedModule = await import('./embeddedModule');
    }
    if (isAutoFreegiftEnabled) {
      autoAddFreegiftModule = await import('./autoAddFreegift');
    }

    if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
      subscriptionUpsellModule = await import('./subscriptionUpsellModule');
    }

    if (isEmbeddedEnabled) {
      embeddedModule.checkEmbeddedCartAndCheckoutPageWidgets({
        widgets,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
      });
    }
    if (isAutoFreegiftEnabled) {
      const filteredWidgets = filterWidgets({
        offerTypes: ['freegift'],
        displayType: 'embedded',
        widgets,
        availingType: 'auto_add',
        triggerTypes: ['cart_page', 'checkout_page'],
      });
      if (filteredWidgets.length > 0) {
        autoAddFreegiftModule.checkFGAutoAddCartAndCheckoutPageOffer({
          widgets: filteredWidgets,
          cartPageDiscountConfig,
          isDiscountCodeEnabled,
        });
      }
    }

    if (isShipProEnabled) {
      shipProModule = await import('./shipProModule');
      shipProModule.checkShippingProtectionAndDisplay({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        widgets,
      });
    }

    if (isCVBEnabled) {
      await cvbModule.checkCVBAndDisplay({
        retryContainerCreation: true,
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        widgets,
      });
    }

    if (isSubscriptionUpsellEnabled && isShopifyFunctionsEnabled) {
      subscriptionUpsellModule.checkSubscriptionUpsellAndDisplay({
        widgets,
      });
    }

    const cartDiscountModule = await import('../cartDiscount');
    cartDiscountModule.checkAndUpdateCartDiscount({
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
    });
  });
};

function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
}

export async function openCartDrawer({ cartIconConfig }) {
  logger.log('open drawer');
  let { selector } = cartIconConfig;
  if (
    [
      'bfnky.myshopify.com',
      'eske-demo.myshopify.com',
      'arearugs-com.myshopify.com',
      'onepricerugs.myshopify.com',
      'naturisimo-store.myshopify.com',
      'wonder-skull.myshopify.com',
    ].includes(getShop())
  ) {
    await sleep(500);
  }
  if (['matural-in.myshopify.com'].includes(getShop())) {
    await sleep(1000);
  }

  if (getShop() === 'naminaturalbeauty.myshopify.com') {
    await sleep(1000);
  }

  if (!selector) {
    selector = mr_cart_icon_selector;
  }
  const clickElements = document.querySelectorAll(selector);
  for (let i = 0; i < clickElements.length; i += 1) {
    const element = clickElements[i];
    if (
      getOpenDrawer() === 'true' &&
      (element.offsetHeight > 0 || element.getBoundingClientRect().height > 0)
    ) {
      setOpenDrawer('false');
      for (let j = 0; j < 20; j += 1) {
        if (window.isMonkUpsellInitDone) {
          logger.log(j);
          break;
        } else {
          await sleep(100);
        }
      }
      handleElementClick(element);
      logger.log('clicked cart icon', element);
      break;
    }
  }
}

export async function clickCheckout() {
  const clickElements = document.querySelectorAll(mr_c_s);
  for (let i = 0; i < clickElements.length; i += 1) {
    const element = clickElements[i];
    if (
      element.offsetHeight > 0 ||
      element.getBoundingClientRect().height > 0
    ) {
      handleElementClick(element);
      break;
    }
  }
}

let classChangeObs;
export const registerClassChangeListener = ({
  selector,
  newClass,
  onFound,
}) => {
  classChangeObs = new MutationObserver(async mutations => {
    const elementsToLookFor = document.querySelectorAll(selector);
    let found = false;
    for (let i = 0; i < mutations.length; i += 1) {
      const mutation = mutations[i];
      for (let j = 0; j < elementsToLookFor.length; j += 1) {
        if (elementsToLookFor[j] === mutation.target) {
          if (mutation && mutation.target && mutation.target.classList) {
            if (mutation.target.classList.contains(newClass)) {
              onFound();
              found = true;
              break;
            }
          }
        }
      }
      if (found) {
        break;
      }
    }
  });

  classChangeObs.observe(document.body, {
    attributes: true,
    subtree: true,
    childList: true,
  });
};

let styleChangeObs;
const registerStyleChangeListener = ({
  selector,
  attributeName,
  attributeValue,
  onFound,
}) => {
  styleChangeObs = new MutationObserver(async mutations => {
    for (let i = 0; i < mutations.length; i += 1) {
      const record = mutations[i];
      if (
        record.target.style &&
        record.target.style[attributeName] === attributeValue
      ) {
        onFound();
        break;
      }
    }
  });

  const targetElement = document.querySelector(selector);
  if (targetElement) {
    styleChangeObs.observe(targetElement, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }
};

export const init = async ({
  isPopupEnabled,
  isVDAboveATCEnabled,
  isProductAddonsAboveATCEnabled,
  isAnyFeatureEnabled,
  cartPageDiscountConfig,
  isDiscountCodeEnabled,
  isShipProEnabled,
  isCVBEnabled,
  isSubscriptionUpsellEnabled,
  isShopifyFunctionsEnabled,
  isEmbeddedEnabled,
  isAutoFreegiftEnabled,
  cartIconConfig,
  store,
  widgets,
  buttonSelectors,
}) => {
  try {
    // setup additional settings to be used by register method
    registerSettings.isPopupEnabled = isPopupEnabled;
    registerSettings.isVDAboveATCEnabled = isVDAboveATCEnabled;
    registerSettings.isProductAddonsAboveATCEnabled = isProductAddonsAboveATCEnabled;
    registerSettings.cartPageDiscountConfig = cartPageDiscountConfig;
    registerSettings.isDiscountCodeEnabled = isDiscountCodeEnabled;
    registerSettings.store = store;
    registerSettings.widgets = widgets;
    registerSettings.isCVBEnabled = isCVBEnabled;
    registerSettings.buttonSelectors = buttonSelectors;

    register({
      isPopupEnabled,
      isVDAboveATCEnabled,
      isProductAddonsAboveATCEnabled,
      cartPageDiscountConfig,
      isDiscountCodeEnabled,
      store,
      widgets,
      isCVBEnabled,
      buttonSelectors,
    });
    mrObs.observe(document.body, {
      childList: true,
      subtree: true,
    });

    registerMagic();
    addMagicLoadListener();

    if (isAnyFeatureEnabled) {
      await registerCartIconClick({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        isShipProEnabled,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAnyFeatureEnabled,
        isAutoFreegiftEnabled,
        cartIconConfig,
        widgets,
      });
      await openCartDrawer({ cartIconConfig });

      cartIconObs = new MutationObserver(mutations => {
        const cartIcons = document.querySelectorAll(mr_cart_icon_selector);
        for (let i = 0; i < mutations.length; i += 1) {
          const mutation = mutations[i];
          if (mutation.type === 'childList') {
            for (let j = 0; j < mutation.addedNodes.length; j += 1) {
              const added = mutation.addedNodes[j];
              for (let k = 0; k < cartIcons.length; k += 1) {
                if (added.contains(cartIcons[k])) {
                  registerCartIconClick({
                    cartPageDiscountConfig,
                    isDiscountCodeEnabled,
                    isShipProEnabled,
                    isCVBEnabled,
                    isSubscriptionUpsellEnabled,
                    isShopifyFunctionsEnabled,
                    isEmbeddedEnabled,
                    isAnyFeatureEnabled,
                    isAutoFreegiftEnabled,
                    cartIconConfig,
                    widgets,
                  });
                }
              }
            }
          }
        }
      });

      if (getShop() === 'bfnky.myshopify.com') {
        cartIconObs.observe(document.body, {
          attributes: true,
          subtree: true,
          childList: true,
        });
      }
    }

    if (isEmbeddedEnabled || isCVBEnabled || isAutoFreegiftEnabled) {
      await cartPageOfferOnHoverRegister({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        isShipProEnabled,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAutoFreegiftEnabled,
        widgets,
      });

      registerDocumentPageDisplay({
        cartPageDiscountConfig,
        isDiscountCodeEnabled,
        isShipProEnabled,
        isCVBEnabled,
        isSubscriptionUpsellEnabled,
        isShopifyFunctionsEnabled,
        isEmbeddedEnabled,
        isAutoFreegiftEnabled,
        widgets,
      });
    }
  } catch (e) {
    logRuntimeError({
      errorMessage: `${e.name} ${e.message}`,
      errorData: {
        fileName: 'shopEventModule',
        level: 'error',
        functionName: 'init',
      },
      errorStack: e,
    });
  }
};

function getProductInformation(event) {
  const isSellingPlanEnabled = getIsSellingPlanEnabled(event.target);
  const variantsWithQuantity = getVariantsWithQuantityFromEvent(
    event,
    isSellingPlanEnabled,
  );

  return {
    handle: getProductHandleFromURL(),
    isSellingPlanEnabled,
    variantsWithQuantity,
    properties: getProductPropertiesFromTarget(event.target),
  };
}

function getVariantsWithQuantityWithVDOptionQuantity({
  event,
  defaultVariantID,
  currVariantsWithQuantity = [],
  volumeDiscountPageState,
}) {
  const {
    isVDVariantSelectorInViewForAboveATC,
    selectedVariants,
    selectedVDOption,
  } = volumeDiscountPageState;

  if (isVDVariantSelectorInViewForAboveATC) {
    return selectedVariants.reduce((result, variant) => {
      const currVariantInResultIndex = result.findIndex(
        x => x.sp_variant_id === variant.spVariantID,
      );

      if (currVariantInResultIndex > -1) {
        result.splice(currVariantInResultIndex, 1, {
          ...result[currVariantInResultIndex],
          quantity: result[currVariantInResultIndex].quantity + 1,
        });
      } else {
        result.push({
          sp_variant_id: variant.spVariantID,
          quantity: 1,
          properties: getProductPropertiesFromTarget(event.target),
        });
      }

      return result;
    }, []);
  }

  const { minValue } = selectedVDOption;
  const differenceQuantity =
    minValue -
    currVariantsWithQuantity.reduce(
      (total, variant) => total + variant.quantity,
      0,
    );

  if (differenceQuantity > 0) {
    const lastIndex = currVariantsWithQuantity.length - 1;

    const updatedItem =
      lastIndex > -1
        ? {
            ...currVariantsWithQuantity[lastIndex],
            quantity:
              currVariantsWithQuantity[lastIndex].quantity + differenceQuantity,
          }
        : {
            sp_variant_id: defaultVariantID,
            quantity: differenceQuantity,
            properties: getProductPropertiesFromTarget(event.target),
          };

    currVariantsWithQuantity[lastIndex > -1 ? lastIndex : 0] = updatedItem;
  }

  return currVariantsWithQuantity;
}

const getUpdatedGiftProductsWithRepetetion = ({
  triggerQty,
  offerLevelDiscountQuantity,
  variantsToAdd,
  discountQtyAfterRepetetion,
}) => {
  // totalGiftQtyRemaining is the total quantity of the gift products that can be added to the cart
  // the variable currVariantsWithQuantity contains the details such as id, quantity of the trigger product
  let totalGiftQtyRemaining = triggerQty * offerLevelDiscountQuantity;

  const selectedVariants = [...variantsToAdd];

  // variable i is used as an index in the while loop below.
  let i = 0;
  let discountQtyReached = false;
  // We can only add gift products to the cart when the discount quantity hasn't reached and there gift products present to be added to the cart
  while (totalGiftQtyRemaining > 0 && !discountQtyReached) {
    // if the product level discount quantity isn't reached, we can add the product to the cart
    if (selectedVariants[i].quantityToAdd < discountQtyAfterRepetetion) {
      selectedVariants[i].quantityToAdd += 1;
      discountQtyReached = false;
      totalGiftQtyRemaining -= 1;
    }
    // We have to set discountQtyReached as true if the product level discount quantity is reached
    if (selectedVariants[i].quantityToAdd >= discountQtyAfterRepetetion) {
      discountQtyReached = true;
    }
    // when we reach the end of the selectedVariants array, we have to start from the beginning for the next iteration
    // so we have to reset the i to 0
    // The reason for starting the iteration again is if the totalGiftQtyRemaining is greater than 0, it means there are more products to be added to the cart
    // Se we iterate through the selectedVariants array, adding one more quantities of each variants to the cart
    if (i === selectedVariants.length - 1) {
      i = 0;
    } else {
      // If we haven't reached the end of the selectedVariants array, we have to increment the i
      // we do this so that we can iterate through the selectedVariants array
      i += 1;
    }
  }
  return selectedVariants;
};

function getVariantsWithQuantityWithProducAddons({
  currVariantsWithQuantity,
  embeddedPageState,
  isSellingPlanEnabled = false,
}) {
  const {
    selectedCheckboxProducts,
    theme,
    discountQuantity,
    offerLevelDiscountQuantity,
    isConsiderRepetetionOfRules,
  } = embeddedPageState;

  // below function gives us variants array from selected products
  const getVariantsFromSelectedProducts = () =>
    selectedCheckboxProducts.map(product => product.variants[0]);

  // below variable is the quantity of the trigger product
  const triggerQty = +currVariantsWithQuantity[0].quantity.toString().slice();
  const discountQtyAfterRepetetion = discountQuantity * triggerQty;

  const selectedVariants = isConsiderRepetetionOfRules
    ? getUpdatedGiftProductsWithRepetetion({
        triggerQty,
        offerLevelDiscountQuantity,
        variantsToAdd: getVariantsFromSelectedProducts(),
        discountQtyAfterRepetetion,
      })
    : getVariantsFromSelectedProducts();

  return [
    ...currVariantsWithQuantity,
    ...selectedVariants.map(variant => {
      const variantData = {
        sp_variant_id: variant.id,
        properties: getMonkDiscountProperties({
          isDiscountDisabled:
            selectedVariants.reduce(
              (total, x) => total + x.calculatedDiscountFloat,
              0,
            ) <= 0,
          off: '',
          offerType: 'crossell',
          properties: {},
          discountQuantity: 1,
          isDiscountQuantityRestricted: true,
          cartDiscountText: theme.cartDiscountText,
        }),
        quantity: isConsiderRepetetionOfRules ? variant.quantityToAdd : 1,
      };
      if (isSellingPlanEnabled && variant.selling_plan)
        variantData.selling_plan = variant.selling_plan;

      return variantData;
    }),
  ];
}

function registerMagic() {
  // for razorpay don't add normal click listener
  if (isMagicInstalled()) {
    if (!window.isMrMagicListenerAdded) {
      window.RazorpayMagicCheckout.events.subscribe(
        'shopify:checkout_init',
        monkCheckout,
      );
      window.isMrMagicListenerAdded = true;
    }
  }
}

function addMagicLoadListener() {
  window.addEventListener('razorpay_magic_load', () => {
    registerMagic();
  });
}

async function storeSpecificShopifyFunctionsCheckout({
  shopifyFunctionsCheckoutURL,
  appliedShopifyFunctionCodes,
  isStorefrontCart,
}) {
  logger.log(
    shopifyFunctionsCheckoutURL,
    appliedShopifyFunctionCodes,
    isStorefrontCart,
  );
  if (
    shopifyFunctionsCheckoutURL &&
    (isStorefrontCart ||
      ['boti-colombia.myshopify.com', 'minimalistinc.myshopify.com'].includes(
        getShop(),
      ))
  ) {
    const checkoutURL = new window.URL(shopifyFunctionsCheckoutURL);
    // have to add the query parameters to checkout url as the old method doesn't work anymore
    if (appliedShopifyFunctionCodes && appliedShopifyFunctionCodes.length > 0) {
      if (
        [
          'raised-by-coyotes.myshopify.com',
          'biblesocks.myshopify.com',
          'marina-group-llc.myshopify.com',
          'cura-marketing.myshopify.com',
        ].includes(getShop())
      ) {
        const extCodes = getExternalDiscountCodeForFunctions();
        if (extCodes) {
          appliedShopifyFunctionCodes.push(extCodes);
        }
      }

      checkoutURL.searchParams.set(
        'discount',
        appliedShopifyFunctionCodes.join(','),
      );
      checkoutURL.searchParams.set('locale', getLocale());

      const { city, county } = getCityAndCounty();
      if (city) {
        checkoutURL.searchParams.set('checkout[shipping_address][city]', city);
      }

      if (county) {
        checkoutURL.searchParams.set(
          'checkout[shipping_address][address2]',
          county,
        );
      }
    }

    await beforCheckout(getShop());
    logger.log('going', checkoutURL.href);

    window.location = checkoutURL.href;
    return true;
  }

  if (!appliedShopifyFunctionCodes) {
    return false;
  }

  if (appliedShopifyFunctionCodes.length === 0) {
    return false;
  }

  if (
    [
      'millyandcoup.myshopify.com',
      'newstatebags.myshopify.com',
      '614d8d-2.myshopify.com',
    ].includes(getShop())
  ) {
    goToCheckout({
      discountCodes: appliedShopifyFunctionCodes,
      isStorefrontCart,
    });
    return true;
  }

  return false;
}

const beforCheckout = async shopURL => {
  if (shopURL === 'muse-india.myshopify.com') {
    if (window.mymuseoncheckoutclick) {
      await window.mymuseoncheckoutclick({
        target: {
          id: 'checkou_minicart_button',
        },
      });
    }
  }
};
